import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { LocalStorageService } from "../services/storage-service/local-storage.service";
import { NO_STORE_CATCH_URL_DATA } from "../global/constants";

@Injectable()
export class RequestInterceptorInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authorization =
      this.localStorageService.getLocalStore("authorization");
    const userIp = this.localStorageService.getLocalStore("userIp");
    const decodedToken =
      authorization && authorization !== "{}"
        ? this.localStorageService.decodeJWT(authorization)
        : undefined;
    const companyId =
      decodedToken?.company_id ||
      this.localStorageService.getLocalStore("currentCompany");

    let headers = request.headers
      .set("X-Custom-Header", `${userIp}`)
      .set("X-Custom-Header-device", "web");

    if (authorization && authorization !== "{}") {
      headers = headers.set("authorization", "Bearer " + authorization);
    }

    if (companyId && companyId !== "{}") {
      headers = headers.set("company_id", String(companyId));
    }

    // Conditionally add 'Cache-Control' header
    if (request.url.includes(NO_STORE_CATCH_URL_DATA[0])) {
      headers = headers.set("Cache-Control", "no-cache");
    }
    const authReq = request.clone({ headers });

    return next.handle(authReq);
  }
}
